'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BrokenHeartIcon = function BrokenHeartIcon(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement(
            'defs',
            null,
            _react2.default.createElement('rect', {
                id: 'b',
                width: '779',
                height: '600',
                rx: '10'
            }),
            _react2.default.createElement(
                'filter',
                {
                    x: '-2.1%',
                    y: '-2.3%',
                    width: '104.1%',
                    height: '105.3%',
                    filterUnits: 'objectBoundingBox',
                    id: 'a'
                },
                _react2.default.createElement('feOffset', {
                    dy: '2',
                    'in': 'SourceAlpha',
                    result: 'shadowOffsetOuter1'
                }),
                _react2.default.createElement('feGaussianBlur', {
                    stdDeviation: '5',
                    'in': 'shadowOffsetOuter1',
                    result: 'shadowBlurOuter1'
                }),
                _react2.default.createElement('feColorMatrix', {
                    values: '0 0 0 0 0.6 0 0 0 0 0.6 0 0 0 0 0.6 0 0 0 0.5 0',
                    'in': 'shadowBlurOuter1'
                })
            )
        ),
        _react2.default.createElement(
            'g',
            {
                fill: 'none',
                fillRule: 'evenodd'
            },
            _react2.default.createElement('path', {
                d: 'M-399 101h940',
                stroke: '#555',
                strokeDasharray: '1,5',
                strokeLinecap: 'square'
            }),
            _react2.default.createElement(
                'text',
                {
                    fontFamily: 'Lato-Regular, Lato',
                    fontSize: '16',
                    fill: '#14141C',
                    transform: 'translate(-399 -71)'
                },
                _react2.default.createElement(
                    'tspan',
                    {
                        x: '244',
                        y: '209'
                    },
                    'If any of this information doesn\u2019t look accurate, '
                ),
                ' ',
                _react2.default.createElement(
                    'tspan',
                    {
                        x: '573.184',
                        y: '209',
                        textDecoration: 'underline'
                    },
                    'please contact us'
                ),
                ' ',
                _react2.default.createElement(
                    'tspan',
                    {
                        x: '692.736',
                        y: '209'
                    },
                    '.'
                )
            ),
            _react2.default.createElement(
                'text',
                {
                    fontFamily: 'Lato-Bold, Lato',
                    fontSize: '16',
                    fontWeight: 'bold',
                    fill: '#14141C',
                    transform: 'translate(-399 -71)'
                },
                _react2.default.createElement(
                    'tspan',
                    {
                        x: '68',
                        y: '51'
                    },
                    ' \u2022 Drivers:'
                ),
                ' ',
                _react2.default.createElement(
                    'tspan',
                    {
                        x: '161.688',
                        y: '51',
                        fontFamily: 'Lato-Regular, Lato',
                        fontWeight: 'normal'
                    },
                    ' Lorem, Ipsum, Dolor'
                ),
                '  ',
                _react2.default.createElement(
                    'tspan',
                    {
                        x: '68',
                        y: '77'
                    },
                    ' \u2022 Year built:'
                ),
                ' ',
                _react2.default.createElement(
                    'tspan',
                    {
                        x: '178.344',
                        y: '77',
                        fontFamily: 'Lato-Regular, Lato',
                        fontWeight: 'normal'
                    },
                    ' 100,000'
                ),
                '  ',
                _react2.default.createElement(
                    'tspan',
                    {
                        x: '68',
                        y: '103'
                    },
                    ' \u2022 Business Usage:'
                ),
                ' ',
                _react2.default.createElement(
                    'tspan',
                    {
                        x: '217.656',
                        y: '103',
                        fontFamily: 'Lato-Regular, Lato',
                        fontWeight: 'normal'
                    },
                    ' No'
                )
            ),
            _react2.default.createElement(
                'text',
                {
                    fontFamily: 'Lato-Bold, Lato',
                    fontSize: '16',
                    fontWeight: 'bold',
                    fill: '#14141C',
                    transform: 'translate(-399 -71)'
                },
                _react2.default.createElement(
                    'tspan',
                    {
                        x: '468',
                        y: '51'
                    },
                    ' \u2022 Number of claims: '
                ),
                ' ',
                _react2.default.createElement(
                    'tspan',
                    {
                        x: '636.224',
                        y: '51',
                        fontFamily: 'Lato-Regular, Lato',
                        fontWeight: 'normal'
                    },
                    'Lorem (2), Ipsum (3), Dolor (0)'
                ),
                ' ',
                _react2.default.createElement(
                    'tspan',
                    {
                        x: '468',
                        y: '77'
                    },
                    ' \u2022 Mortgage:'
                ),
                ' ',
                _react2.default.createElement(
                    'tspan',
                    {
                        x: '578.432',
                        y: '77',
                        fontFamily: 'Lato-Regular, Lato',
                        fontWeight: 'normal'
                    },
                    ' Yes'
                ),
                ' ',
                _react2.default.createElement(
                    'tspan',
                    {
                        x: '468',
                        y: '103',
                        fontFamily: 'Lato-Regular, Lato',
                        fontWeight: 'normal'
                    },
                    ' '
                ),
                ' ',
                _react2.default.createElement(
                    'tspan',
                    {
                        x: '479',
                        y: '103'
                    },
                    '\u2022 Special discounts:'
                ),
                ' ',
                _react2.default.createElement(
                    'tspan',
                    {
                        x: '630.744',
                        y: '103',
                        fontFamily: 'Lato-Regular, Lato',
                        fontWeight: 'normal'
                    },
                    ' Lorem ipsum dolor sit amet'
                ),
                ' ',
                _react2.default.createElement(
                    'tspan',
                    {
                        x: '468',
                        y: '129'
                    },
                    ' \u2022 '
                ),
                ' ',
                _react2.default.createElement(
                    'tspan',
                    {
                        x: '504',
                        y: '129'
                    },
                    'Deductibles:'
                ),
                ' ',
                _react2.default.createElement(
                    'tspan',
                    {
                        x: '594.128',
                        y: '129',
                        fontFamily: 'Lato-Regular, Lato',
                        fontWeight: 'normal'
                    },
                    ' Lorem ipsum dolor sit amet'
                )
            ),
            _react2.default.createElement(
                'g',
                null,
                _react2.default.createElement('path', {
                    fill: '#999',
                    opacity: '.5',
                    d: 'M-649-144H791v1257H-649z'
                }),
                _react2.default.createElement(
                    'g',
                    {
                        transform: 'translate(-318 -41)'
                    },
                    _react2.default.createElement('use', {
                        fill: '#000',
                        filter: 'url(#a)',
                        xlinkHref: '#b'
                    }),
                    _react2.default.createElement('use', {
                        fill: '#FFF',
                        xlinkHref: '#b'
                    })
                ),
                _react2.default.createElement('path', {
                    fill: '#FFC400',
                    d: 'M65.9 17.14h5.714V0H65.9zM40.474 25.487L31.903 10.64l4.948-2.857 8.572 14.846zM22.628 45.425L7.783 36.854l2.857-4.949 14.845 8.572zM0 71.615h17.143v-5.714H0zM10.639 105.614l-2.857-4.949 14.845-8.571 2.858 4.948zM36.853 129.735l-4.949-2.857 8.571-14.846 4.949 2.857zM65.9 137.518h5.714v-17.143H65.9zM100.664 129.735l-8.571-14.846 4.948-2.857 8.572 14.846zM126.878 105.614l-14.846-8.572 2.857-4.948 14.846 8.571zM120.374 71.615h17.143v-5.714h-17.143zM114.888 45.425l-2.857-4.948 14.846-8.572 2.857 4.949zM97.042 25.487l-4.948-2.857 8.571-14.846 4.949 2.857z'
                }),
                _react2.default.createElement('path', {
                    d: 'M83.446 35c-5.765 0-11.204 2.677-14.912 7.258C64.822 37.678 59.385 35 53.62 35 42.8 35 34 44.282 34 55.691c0 4.724 1.477 9.177 4.278 12.88.012.019.027.04.042.058.672.884 26.16 31.36 29.063 34.832a1.491 1.491 0 0 0 2.298 0c2.906-3.47 28.394-33.948 29.017-34.77.063-.068.119-.142.167-.221 2.75-3.681 4.202-8.097 4.202-12.779 0-11.41-8.802-20.691-19.621-20.691m0 4.495c8.34 0 15.127 7.266 15.127 16.196 0 3.7-1.145 7.19-3.309 10.091l-.109.145-.006.006c-.71.898-13.881 16.669-26.615 31.897C55.86 82.672 42.88 67.132 41.92 65.938l-.01-.012-.047-.066c-2.204-2.916-3.368-6.43-3.368-10.169 0-8.93 6.784-16.196 15.125-16.196 4.38 0 8.542 2.037 11.421 5.591l3.493 4.31 3.492-4.31c2.878-3.554 7.04-5.591 11.42-5.591',
                    fill: '#555'
                }),
                _react2.default.createElement('path', {
                    stroke: '#555',
                    strokeWidth: '4',
                    d: 'M69 46l-8 12.5 13.5 8-11 11L69 101'
                })
            )
        )
    );
};

BrokenHeartIcon.defaultProps = {
    width: '138',
    height: '138',
    viewBox: '0 0 138 138',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink'
};

var BrokenHeart = function (_React$Component) {
    _inherits(BrokenHeart, _React$Component);

    function BrokenHeart() {
        _classCallCheck(this, BrokenHeart);

        return _possibleConstructorReturn(this, (BrokenHeart.__proto__ || Object.getPrototypeOf(BrokenHeart)).apply(this, arguments));
    }

    _createClass(BrokenHeart, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(BrokenHeartIcon, null);
        }
    }]);

    return BrokenHeart;
}(_react2.default.Component);

exports.default = BrokenHeart;